"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // @ts-nocheck


var getBasePlacement_1 = tslib_1.__importDefault(require("./getBasePlacement"));

var getVariation_1 = tslib_1.__importDefault(require("./getVariation"));

var getMainAxisFromPlacement_1 = tslib_1.__importDefault(require("./getMainAxisFromPlacement"));

var enums_1 = require("../enums");
/**
 *
 */


function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement_1["default"](placement) : null;
  var variation = placement ? getVariation_1["default"](placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_1.top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case enums_1.bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case enums_1.right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case enums_1.left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement_1["default"](basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case enums_1.start:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
        break;

      case enums_1.end:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

exports["default"] = computeOffsets;